import { fetchData } from '@/lib/api/fetchData';
import type { DateRange, SupportedLanguage } from '@/utils';

export type PeriodFilterPayload = Partial<Record<string, unknown>> & {
  period: DateRange;
};

type FetchPeriodFilterParams = {
  filters: PeriodFilterPayload;
  group: string;
  lang: SupportedLanguage;
};

export function fetchPeriodFilter({ filters, group, lang }: FetchPeriodFilterParams) {
  return fetchData<DateRange>(
    'period_filter/',
    {
      params: {
        filters: JSON.stringify(filters),
        group,
        lang,
      },
    },
    true
  );
}
